import { render, staticRenderFns } from "./VisualizadorPdf.vue?vue&type=template&id=995d7eea&scoped=true&"
import script from "./VisualizadorPdf.vue?vue&type=script&lang=js&"
export * from "./VisualizadorPdf.vue?vue&type=script&lang=js&"
import style0 from "./VisualizadorPdf.vue?vue&type=style&index=0&id=995d7eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995d7eea",
  null
  
)

export default component.exports